import apiService from '@/services/apiService'

// Ventas cobradas con ticket, para facturarlas en el sistema externo —
// pos-graciela-api/docs/SPEC_VENTAS_INNOMINADAS_FACTURACION_DIFERIDA_v0.1.md
// RN-VI6 y RN-VI7.

const BASE = '/api/ventas-pendientes-factura'

function buildParams(filters = {}) {
  const params = {}
  for (const [key, value] of Object.entries(filters)) {
    if (value !== null && value !== undefined && value !== '') params[key] = value
  }
  return params
}

async function listar(filters) {
  const { data } = await apiService.get(BASE, buildParams(filters))
  return data?.data || null
}

// Mismo criterio que reportsService.descargarCsv: blob, para que viaje el
// header de autenticación.
async function descargarCsv(filters) {
  const response = await apiService.get(BASE, { ...buildParams(filters), formato: 'csv' }, { responseType: 'blob' })
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }))
  const link = document.createElement('a')
  link.href = url
  link.download = `ventas-pendientes-factura-${Date.now()}.csv`
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

async function marcar({ ids, referencia, fecha }) {
  const { data } = await apiService.post(`${BASE}/marcar`, { ids, referencia, fecha })
  return data?.data
}

async function desmarcar({ ids, motivo }) {
  const { data } = await apiService.post(`${BASE}/desmarcar`, { ids, motivo })
  return data?.data
}

export default { listar, descargarCsv, marcar, desmarcar }
